import { Model } from './model';

export class Path {
  constructor(
    public hash: string,
    public order: number,
    public route: string,
    public model: Model
  ) { }

  clone() {
    return new Path (
      this.hash,
      this.order,
      this.route,
      this.model
    );
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/path.ts